window.addEventListener('DOMContentLoaded', (event) => {

    // get all footer .wp-block-heading
    let  tabs = document.querySelectorAll('footer .wp-block-heading');

    // loop through each tab

    if(tabs){

        tabs.forEach(tab => {
            // get next nav sibling 
            let nav = tab.nextElementSibling;
            // add click event listener
            tab.addEventListener('click', () => {
                 // check if the screen is less than 780px
                if(window.innerWidth < 780){
                // toggle class
                nav.classList.toggle('is-open');
                // add class to tab
                tab.classList.toggle('is-open');
                }


                
            });
           
        });
       
    }




});